import React, { useContext } from 'react'
import { AppContext } from '../contexts'
import { TypeAppContext } from '../contexts'

const useAppContext = (): TypeAppContext => {
    return useContext(AppContext)
}

export default useAppContext
